import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Button, Row, Col, Icon, Popover } from 'antd';
//import { Link } from 'react-router';

export default class VersionCheckerComponent extends React.Component {

    static propTypes = {
        version: PropTypes.object.isRequired,
        action: PropTypes.func.isRequired
    }

    render() {
        const { masterVersion, shouldReload } = this.props.version;
        const { action } = this.props;
        const popOverContent = (
            <div className='version-popup'>
                <div>
                    When you are on our site, your browser polls the server every 5 minutes to see if there are important updates, and if there are, this alert is displayed.
                    When you click the link or press the button, the browser refreshes, the new changes load and the alert goes away until the next set of important updates. If you click the button
                    but the alert is still there after a few minutes, please try again, as it might just be that the web server is still catching up with the changes.
                </div>
                <div>
                    We do this because Yes.Fit is a <a href='https://en.wikipedia.org/wiki/Single-page_application' target='_blank'>Single Page Application</a>.
                </div>
            </div>
        );

        //There is a new version of the Yes.Fit web site. <a onClick={reload}>Please reload to ensure a trouble-free experience.</a>
        
        const ShouldReload = (
            <Row>
                <Col span={18}>
                    There is a new version of the Yes.Fit web site. <a onClick={action}>Please reload to ensure a trouble-free experience.</a> <Popover content={popOverContent} title='What is this?'>
                        <Icon type='info-circle-o' />
                    </Popover>
                </Col>
                <Col span={6}>
                    {<Button type='primary' onClick={action}><Icon type='reload' />Load v{masterVersion}</Button>}
                </Col>
            </Row>
        );

        return (
            <div className='version'>
                {shouldReload &&
                    <Alert message={ShouldReload} banner />
                }
            </div>
        )
    }
}